import React from "react";
import { Link } from "react-router-dom";
import ViewProfileIcon from "../../../../assets/icons/ViewProfileIcon.svg";
import TalentIdentity from "../molecules/TalentIdentity";
import DetailRow from "../atoms/DetailRow";
import AiScoreRow from "../atoms/AiScoreRow";
import ExpIcon from '../../../../assets/icons/ExpIcon.svg'
import LocIcon from '../../../../assets/icons/LocIcon.svg'

const getDisplayValue = (value) => {
  if (value === null || value === undefined) return "N/A";

  if (typeof value === "string") return value.trim() ? value : "N/A";

  if (typeof value === "number" || typeof value === "boolean") return String(value);

  if (Array.isArray(value)) {
    if (!value.length) return "N/A";
    return getDisplayValue(value[0]);
  }

  if (typeof value === "object") {
    
    if (value.title || value.company_name) {
      const parts = [
        value.title,
        value.company_name ? `@ ${value.company_name}` : null,
        value.locality ? `(${value.locality})` : null,
      ].filter(Boolean);
      return parts.length ? parts.join(" ") : "N/A";
    }

    if (value.locality || value.city || value.name) {
      return value.locality || value.city || value.name || "N/A";
    }

    try {
      return JSON.stringify(value);
    } catch {
      return "N/A";
    }
  }

  return "N/A";
};

const ExternalTalentCard = ({
  talent,
  onViewProfile,
  profileUrl,
  selectable = false,
  selected = false,
  onToggleSelect,
}) => {
  const talentId = talent.id || talent._id;

  return (
  <div
    className={`qp-card qp-card-external ${selectable ? "qp-card-selectable" : ""} ${selected ? "qp-card-selected" : ""}`}
    onClick={() => (selectable ? onToggleSelect?.(talentId) : null)}
  >
    {selectable && (
      <label className="qp-card-select" onClick={(event) => event.stopPropagation()}>
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onToggleSelect?.(talentId)}
          aria-label={`Select ${talent.name}`}
        />
      </label>
    )}

    <TalentIdentity
      name={talent.name}
      title={talent.title}
      avatar={talent.avatar}
      initials={talent.initials}
      online={talent.online}
    >
      <AiScoreRow aiScore={talent.aiScore} />
    </TalentIdentity>

    <div className="qp-card-details">
      <DetailRow
        icon={<img src={ExpIcon} alt="experience" />}
        label="Experience:"
        value={getDisplayValue(talent.totalExperience)}
      />
      <DetailRow
        icon={<img src={LocIcon} alt="location" />}
        label="Location"
        value={getDisplayValue(talent.location)}
      />
    </div>

    {profileUrl ? (
      <Link
        className="qp-btn-view-full"
        to={profileUrl}
        onClick={(event) => event.stopPropagation()}
      >
        <img src={ViewProfileIcon} alt="" /> View Profile
      </Link>
    ) : (
      <button
        className="qp-btn-view-full"
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          onViewProfile?.(talentId);
        }}
      >
        <img src={ViewProfileIcon} alt="" /> View Profile
      </button>
    )}
  </div>
  );
};

export default ExternalTalentCard;
